let {jwt_encode, jwt_decode} = require('../jwt.js');
import { store } from '../store'

export default function auth({ next, to }) {

    let ltiAuthToken = to.query.token;
    let credentials;

    if (! ltiAuthToken) {
        return next('/requiresLti');
    }

    try {
        credentials = jwt_decode(ltiAuthToken).ltiCredentials;

        let lms_picture = credentials.picture;
        let lms_user_name = credentials.user_name;
        let lms_email = credentials.email;
        let lms_sis_user_id = credentials.sis_user_id;
        let lms_sis_course_id = credentials.sis_course_id;
        let lms_given_name = credentials.given_name;
        let lms_family_name = credentials.family_name;

        /*
        console.log(`lms_picture        ${lms_picture}`);
        console.log(`lms_user_name      ${lms_user_name}`);
        console.log(`lms_email          ${lms_email}`);
        console.log(`lms_sis_user_id    ${lms_sis_user_id}`);
        console.log(`lms_sis_course_id  ${lms_sis_course_id}`);
        console.log(`lms_given_name     ${lms_given_name}`);
        console.log(`lms_family_name    ${lms_family_name}`);
        */

        // let ltiProgressToken = jwt_encode(credentials, false, '30d');
        //  this.$store.lastName = credentials.family_name;
        //  this.$store.firstName = credentials.given_name;
        //  this.$store.sis_user_id = credentials.sis_user_id;
        // console.log("DECODED VALUES:: ");
        // console.log("sis_user_id", credentials.sis_user_id);
        // console.log("lastName", credentials.family_name);
        // console.log("firstName", credentials.given_name);

        store.sis_user_id = credentials.sis_user_id;
        store.lastName = credentials.family_name;
        store.firstName = credentials.given_name;

        //  console.log("STORE VALUES:: ");
        //  console.log("sis_user_id", store.sis_user_id);
        //  console.log("lastName", store.lastName);
        //  console.log("firstName", store.firstName);

        // window.$cookies.set('ltiProgress', ltiProgressToken, '30d', null, null, true, "None");
        // let ltiProgressToken = jwt_encode(credentials, false, '30d');

        //  this.$store.authenticated = true;
        store.state.authenticated = true;

        return next('/');

    } catch (e) {
        console.log(`ERROR ${e}`);
        return next('/requiresLti');
    }

}

